var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('DownloadPluginsHead',{attrs:{"filter":_vm.filter},on:{"changeFilter":_vm.changeFilter}}),_c('div',{staticClass:"table-filter-wrap"},[_c('DownloadPluginsUserTable',{attrs:{"filter":_vm.filter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }